//const DEFAULT_API_BASE_URL ='https://pixle-pro-backend-badaaqhudcheandc.uksouth-01.azurewebsites.net/api';
const DEFAULT_API_BASE_URL ='https://api.pixle.pro/api';
//const DEFAULT_API_BASE_URL ='http://localhost:8888/api';

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;

export const API_ORIGIN = new URL(API_BASE_URL).origin;

// Azure Blob Storage base URL used to build playable asset URLs from the
// relative blob path + the SAS token returned on each video document.
export const AZURE_STORAGE_ACCOUNT = 'pixleprostorageaccount';
export const AZURE_COMMON_CONTAINER_NAME = 'pixle-pro-assets';
export const STORAGE_BASE_URL = `https://${AZURE_STORAGE_ACCOUNT}.blob.core.windows.net/${AZURE_COMMON_CONTAINER_NAME}/`;
